export enum E_HomeRotativeItemType {
  HomeSection = 'HomeSection',
  Advertisement = 'Ad',
}